import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  ListAssignedComponentsInput,
  ListAssignedComponentsQueryVariables,
  ListAssignedComponentsResponse,
} from '../types';

const getFlexibleBenefitAssignedComponentsQuery = gql`
  query PayrollListAssignedComponents($input: ListAssignedComponentsInput!) {
    payrollListAssignedComponents(input: $input) {
      code
      success
      message
      total_count
      data {
        assignment_id
        tenant_id
        merchant_id
        component_id
        user_id
        version
        assigned_value
        declared_value
        effective_from
        effective_to
        status
        created_at
        updated_at
        component_name
        component_display_name
      }
    }
  }
`;

export const getFlexibleBenefitAssignedComponents = (input: ListAssignedComponentsInput) => {
  return graphQLApi<ListAssignedComponentsResponse, ListAssignedComponentsQueryVariables>({
    query: getFlexibleBenefitAssignedComponentsQuery,
    queryVariables: { input },
  });
};
